import React from "react";
import classnames from "classnames/bind";
import { Switch, Route, Redirect } from "react-router-dom";

import routes from "./routes";
import css from "./index.scss";
import Footer from "./components/Footer";
import BootstrapNavbar from "./components/BootstrapNavbar";
import FloatingButton from "./components/FloatingButton";

const cx = classnames.bind(css);
const moduleName = "Home";

const Home = () => {
  return (
    <div className={cx(`${moduleName}`)}>
      <BootstrapNavbar />
      <Switch>
        {routes.map(({ ...routeProps }) => (
          <Route
            {...routeProps}
            key={routeProps.path || ""}
            onUpdate={() => window.scrollTo(0, 0)}
          />
        ))}
        <Redirect to="/" />
      </Switch>
      <div className={cx(`${moduleName}-floatingWrapper`)}>
        <FloatingButton />
      </div>
      <Footer />
    </div>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/App/pages/Home/index.js